export const STATE = '/state/'
export const STATE_ALL = `${STATE}all`
